import update from 'react-addons-update';
import urlResolver from 'edrolo/utils/URLResolver';
import Utils from './utils';

const ExamDataFetcher = {
  getInitialState() {
    return {
      examData: { sections: [] },
      examLoaded: false,
      fetchingExamData: false,
    };
  },

  fetchExamData(examId, onSuccess) {
    if (this.state.fetchingExamData) {
      return;
    }
    this.setState({ fetchingExamData: true });

    const url = urlResolver.reverse('api:get:exam-detail', {
      examId,
    });

    $.ajax({
      url,
      dataType: 'json',
      success: (newExamData) => {
        const newData = this.mungeExamData(newExamData);
        this.setState(
          {
            examData: newData,
            examLoaded: true,
            fetchingExamData: false,
          },
          onSuccess
        );
      },
      error: (xhr, status, err) => {
        this.setState({ fetchingExamData: false });
      },
    });
  },

  mungeExamData(newExamData) {
    // Apply whatever manipulations are necessary to the new exam data
    const flatExamData = update(newExamData, {
      total_marks_available: { $set: Utils.addUpMarksAvailable(newExamData) },
      sections: { $set: newExamData.sections.map(Utils.flattenSectionData) },
    });
    return flatExamData;
  },
};

export default ExamDataFetcher;
